import { ServiceBase } from "./ServiceBase";

export class ProdutosServices extends ServiceBase {

    async getAll(url: string) {
        return this.get(url);
    }

}